/** 
 * jQuery: Send new jobalert query to database
 */
 jQuery(document).ready(function ($) {

  /** 
   * Create new job alert ajax function
   */
  jQuery(document).on('click', '#send_new_jobalert', (e) => {

    e.preventDefault();

    // Input placements
    const jobAlertForm = document.querySelector('#jobalert');
    const formData = $('#jobalert').serialize();
    console.log(formData);

    const messageEl = document.querySelector('#jobalert_message');
    const redirectUrl = document.querySelector('#jobalert_redirect_url').value;

    jQuery.ajax({
      type: 'POST',
      url: flexurity__jobalert_ajax.ajaxurl,
      data: {
        action: 'flexurity_send_job_alert_to_db',
        payload: formData,
        nonce: flexurity__jobalert_ajax.security
      },
      beforeSend: function () {
        jobAlertForm.classList.add('loading');
      },
      success: function (response) {
        jobAlertForm.classList.remove('loading');
        window.location = redirectUrl;
      },
      error: function (error) {
        console.log(error);
      }
    });
  });

  /**
   * Delete job alert ajax function
   */
  jQuery(document).on('click', '#delete_jobalert', (e) => {

    e.preventDefault();

    var button = document.querySelector('#delete_jobalert');
    var id = button.dataset.id;
    const replaceble = document.querySelector('#replaceble');

    var correctsign = '<svg xmlns="http://www.w3.org/2000/svg" width="173.984" height="173.984" viewBox="0 0 173.984 173.984">'+
    '  <g id="Icon_ionic-ios-checkmark-circle-outline" data-name="Icon ionic-ios-checkmark-circle-outline" transform="translate(-3.375 -3.375)">'+
    '    <path id="Path_221" data-name="Path 221" d="M100.02,20.278l-7.361-7.57a1.583,1.583,0,0,0-1.171-.5h0a1.519,1.519,0,0,0-1.171.5l-51.024,51.4L20.723,45.539a1.617,1.617,0,0,0-2.342,0l-7.445,7.445a1.666,1.666,0,0,0,0,2.384L34.357,78.789a7.407,7.407,0,0,0,4.893,2.384,7.761,7.761,0,0,0,4.851-2.3h.042l55.918-56.21A1.788,1.788,0,0,0,100.02,20.278Z" transform="translate(34.931 43.699)"/>'+
    '    <path id="Path_222" data-name="Path 222" d="M90.367,15.085a75.294,75.294,0,0,1,53.241,128.523A75.294,75.294,0,0,1,37.126,37.126,74.784,74.784,0,0,1,90.367,15.085m0-11.71a86.992,86.992,0,1,0,86.992,86.992A86.979,86.979,0,0,0,90.367,3.375Z" transform="translate(0 0)"/>'+
    '  </g>'+
    '</svg><br><br><a href="/">Home</a>';
      
    jQuery.ajax({
      type: 'POST',
      url: flexurity__jobalert_ajax.ajaxurl,
      data: {
        action: 'flexurity_jobalert_delete_alert',
        payload: id,
        nonce: flexurity__jobalert_ajax.security
      },
      beforeSend: function () {
        
      },
      success: function (response) {
        replaceble.innerHTML = correctsign;
      },
      error: function (error) {
        console.log(error);
      }
    });
  });

});